import React from 'react';
import useStreamText from './useStreamText';

export default function useSessionSummary(sessionId: string | null) {
  const [result, setResult] = React.useState<string | null>(null);

  const onSummarizeEnd = React.useCallback((finalText: string) => {
    setResult(finalText);
  }, []);

  const {
    mutate, text, loading, error,
  } = useStreamText(onSummarizeEnd);

  const generateSummary = React.useCallback(() => {
    if (sessionId) {
      setResult(null);
      mutate(sessionId);
    }
  }, [sessionId, mutate]);

  return {
    result,
    generateSummary,
    text,
    loading,
    error,
    reset: () => setResult(null),
  };
}
